import React from "react";

/**
 * Skeleton loading blocks — used while data is being fetched.
 * `variant="light"` matches cream/white sections; `variant="dark"` matches
 * ink hero/registry sections. Consumers stack multiple <SkelLine /> or
 * <SkelBlock /> primitives to mock the shape of the final content so the
 * page doesn't jump when the real data arrives.
 */

export function SkelLine({ w = "100%", h = 16, className = "", variant = "light" }) {
  const cls = variant === "dark" ? "gm-skel-dark" : "gm-skel";
  return (
    <div
      className={`${cls} ${className}`}
      style={{ width: w, height: h }}
      aria-hidden
    />
  );
}

export function SkelBlock({ h = 180, className = "", variant = "light", "data-testid": testid }) {
  const cls = variant === "dark" ? "gm-skel-dark" : "gm-skel";
  return (
    <div
      className={`${cls} ${className}`}
      style={{ height: h }}
      data-testid={testid}
      aria-hidden
    />
  );
}

/** Card-shaped skeleton — matches a typical events / certificates card. */
export function SkelCard({ variant = "light" }) {
  return (
    <div
      className={`rounded-2xl border-2 ${
        variant === "dark" ? "border-white/15 bg-white/[0.03]" : "border-[var(--line)] bg-white"
      } p-6 space-y-4`}
      aria-hidden
    >
      <SkelLine w="45%" h={12} variant={variant} />
      <SkelLine w="82%" h={22} variant={variant} />
      <SkelLine w="60%" h={14} variant={variant} />
      <SkelLine w="72%" h={14} variant={variant} />
      <div className="pt-2">
        <SkelLine w="30%" h={12} variant={variant} />
      </div>
    </div>
  );
}

export function LoadingLabel({ children = "Loading", variant = "light" }) {
  const cls = variant === "dark" ? "text-white/60" : "text-[var(--smoke)]";
  return (
    <div className={`flex items-center gap-2 text-sm ${cls}`} role="status" aria-live="polite">
      <span className="inline-block w-2 h-2 rounded-full bg-[var(--panini-red)] animate-pulse" />
      <span>{children}…</span>
    </div>
  );
}
